import { isEqual } from 'lodash';

export const parseSortParamFromStringToObject = (value: string) =>
  isEqual(value[0], '-') ? { [value.slice(1)]: -1 } : { [value]: 1 };
